import styled from 'styled-components';

export const StyledSendToDeskIcon = styled.svg`
    background: none;
    border: none;
`;
